export default "__VITE_ASSET__BMMYRvEs__"